///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Toolbar } from 'ngx-editor';
import { defaultToolbarRules, NoteItem } from './release-notes-note-item.model';

export class GtthReleaseNotesNewRelease implements NoteItem {
    public readonly DIALOG_TITLE_TRANSLATION_PATH = 'releaseNotes.newRelease.createOrEditLabel';
    public fieldList: { title: string; content: string; editorToolbar: Toolbar }[] = [];

    constructor(
        public date?: string,
        public version?: string,
        public content?: string
    ) {
        this.fieldList.push({ title: 'date', content: this.date, editorToolbar: [] });
        this.fieldList.push({ title: 'version', content: this.version, editorToolbar: [] });
        this.fieldList.push({ title: 'content', content: this.content, editorToolbar: defaultToolbarRules });
    }

    getPlainObject(): any {
        const releaseNoteItem = {};
        this.fieldList.forEach((field) => (releaseNoteItem[field.title] = field.content));
        return releaseNoteItem;
    }
}
